module.exports = __webpack_public_path__ + "img/case-logo-43.4d8dfebb.png";